@if (projectId(); as currentProjectId) {
  <div class="sticky top-[52px] z-20 bg-(--surface-card) pb-3 pe-3 ps-6 pr-6 mb-3 rounded-lg">
    <app-progress-dashboard
      [attributesByEvaluationCriteria]="attributesByEvaluationCriteria()"
      [evaluationCriteria]="dashboardDirectusCriteria()"
      [evaluationSubCriteria]="dashboardDirectusSubCriteria()"
      phase="RFI"
    />
  </div>
  <app-contributor-menu-bar
    [projectId]="currentProjectId"
    [showAverageOption]="true"
    [preselectedRole]="ProjectRoleType.CONTRIBUTOR"
    [preselectedAccessiblePages]="[ProjectStepType.RFI_EVALUATION_SUBCRITERIA]"
    (contributorSelected)="onContributorSelected($event)"
  ></app-contributor-menu-bar>
  @if (loading()) {
    <app-loading />
  } @else {
    <app-subcriteria-tabs
      [projectId]="currentProjectId"
      [evaluationCriteriaData]="projectCriteria()"
      [attributesByEvaluationCriteria]="attributesByEvaluationCriteria()"
      [directusSubCriteria]="dashboardDirectusSubCriteria()"
      [contributorEmail]="contributorEmail()"
      [disabled]="isScoringDisabled()"
      [showConsistency]="showConsistency()"
      (saveSuccess)="onSaveSuccess($event)"
      (attributesChanged)="onAttributesChanged($event)"
      (unsavedScoresChanged)="onUnsavedScoresChanged($event)"
    ></app-subcriteria-tabs>
    @if (canFinishStep()) {
      <div class="flex justify-end mt-4">
        <p-button
          [label]="'project.finish.step.label' | transloco"
          (onClick)="finishStep()"
          data-testid="finish-rfi-evaluation-button"
          [disabled]="isFinishingStep()"
        ></p-button>
      </div>
    }
  }
}
